import React from 'react';

const RejectedBadge = () => (
  <span className="px-2 py-0.5 rounded text-xs font-medium text-red-800 bg-red-100">
    Rejected
  </span>
);

export default RejectedBadge;
